import styled from "styled-components";

const NotificationStyle = styled.div`
	position: fixed;
	top: 4rem;
	right: 1rem;
`;

export default NotificationStyle;
